<template>
  <div id="appUpdateIndex">
    <!-- 筛选 -->
    <div class="filter-container searchWarp" style="margin-bottom: -20px;height:50px;">
      <el-input v-show="activeDevice=='appUpdate'" v-model="searchObj.appId" clearable
        :placeholder="$t('appUpdate.AppId')" class="input-with-select" @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-input v-if="activeDevice=='appUpdate'" v-model="searchObj.appName" clearable
        :placeholder="$t('appUpdate.AppName')" class="input-with-select" @clear="changeSearch">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
      </el-input>
      <el-select v-if="activeDevice=='appUpdate'" v-model="searchObj.appType" clearable
        :placeholder="$t('appUpdate.PlatformType')" class="filter-item" filterable style="width: 300px"
        @change="changeSearch">
        <el-option v-for="(item,index) in appTypeOptions" :key="index" :label="item.label" :value="item.key" />
      </el-select>
      <el-button type="primary" icon="el-icon-plus"
        style="vertical-align: top;margin:0 10px;float: right;position: relative;z-index: 999;"
        @click="addOrEdit(null)" />
    </div>
    <el-tabs v-model="activeDevice" style="margin-top:15px;" type="border-card" class="simContentWarp">
      <!-- app 版本管理 -->
      <el-tab-pane :label="$t('sideBar.appUpdateIndex')" name="appUpdate" style="position:relative;">
        <el-table id="feedBackTable" v-loading="loading" :data="tableData" style="width: 100%" border>
          <el-table-column prop="id" :label="$t('eveF477.No')" align="center" width="70" />
          <el-table-column prop="appId" :label="$t('appUpdate.AppId')" align="center" />
          <el-table-column prop="appName" :label="$t('appUpdate.AppName')" align="center" />
          <el-table-column prop="appTypeZh" :label="$t('appUpdate.PlatformType')" align="center" />
          <el-table-column prop="versionName" :label="$t('adminView.Version')" align="center" />
          <el-table-column prop="updateInstallZh" :label="$t('appUpdate.UpgradeMethod')" align="center" />
          <el-table-column prop="downloadUrl" :label="$t('appUpdate.UpgradePath')" align="center" />
          <el-table-column prop="remarkZh" :label="$t('appUpdate.UpgradeInstruct')" align="center" show-overflow-tooltip/>
          <el-table-column prop="updateTime" :label="$t('adminView.Created')" align="center" />
          <el-table-column align="center">
            <template slot="header" slot-scope="scope">
              {{$t('yhubReport.Operating')}}
              <span class="lock_btn" @click="showLock = !showLock">
                <i class="el-icon-unlock" v-if="showLock"></i>
                <i class="el-icon-lock" v-else></i></span>
            </template>
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="addOrEdit(scope.row)" />
              <el-button v-if="showLock" type="danger" size="mini" icon="el-icon-delete"
                @click="deleteOne(scope.row.id)" />
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 应用中心管理 -->
      <el-tab-pane :label="$t('appUpdate.AppCenterMagt')" name="appCenter" style="position:relative;">
        <el-table id="appCenterTable" v-loading="appCenterLoading" :data="appCenterData" style="width: 100%" border>
          <el-table-column prop="id" :label="$t('eveF477.No')" align="center"  />
          <el-table-column prop="appName" :label="$t('appUpdate.AppName')" align="center"  />
          <el-table-column prop="versionZh" :label="$t('adminView.Version')" align="center"  />
          <el-table-column prop="remark" :label="$t('appUpdate.AppNoteZh')" align="center" width="800" />
          <el-table-column prop="updateTimeZh" :label="$t('appUpdate.Uploaded')" align="center"  />
          <el-table-column align="center" >
            <template slot="header" slot-scope="scope">
              {{$t('yhubReport.Operating')}}
              <span class="lock_btn" @click="showLock = !showLock">
                <i class="el-icon-unlock" v-if="showLock"></i>
                <i class="el-icon-lock" v-else></i></span>
            </template>
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="addOrEdit(scope.row)" />
              <el-button v-if="showLock" type="danger" size="mini" icon="el-icon-delete" @click="deleteApp(scope.row)" />
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
     

    </el-tabs>

    <!-- app 升级提示编辑 -->
    <el-dialog :close-on-click-modal="false" width="80%" :visible.sync="addAndEditDialog">
      <div slot="title" class="dialog_title">
        {{popTitle}} <span class="lock_btn" @click="editLock = !editLock"><i class="el-icon-lock" v-if="editLock"></i>
          <i class="el-icon-unlock" v-else></i></span>
      </div>
      <el-form id="batteryPop" ref="popObj" :rules="rules" :model="popObj" label-position="right" label-width="300px">
        <el-row :gutter="40">
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.AppId')" prop="appId">
              <el-input v-model="popObj.appId" :placeholder="$t('lease.Cannotbeblanked2')" :disabled="editLock"
                @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.AppName')" prop="appName">
              <el-input v-model="popObj.appName" :placeholder="$t('lease.Cannotbeblanked2')" :disabled="editLock"
                @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.PlatformType')" prop="appType">
              <el-select v-model="popObj.appType" :placeholder="$t('AllDevices.Status')" class="filter-item" clearable
                filterable style="width: 300px" @change="change" :disabled="editLock">
                <el-option v-for="(item,index) in appTypeOptions" :key="index" :label="item.label" :value="item.key" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.UpgradePath')" prop="downloadUrl">
              <el-input v-model="popObj.downloadUrl" :placeholder="$t('lease.Cannotbeblanked2')" @input="change($event)"
                :disabled="editLock" />
            </el-form-item>
          </el-col>
          <div class="tips">应用版本更新只需修改以下内容</div>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.UpgradeMethod')" prop="updateInstall">
              <el-select v-model="popObj.updateInstall" :placeholder="$t('AllDevices.Status')" class="filter-item"
                style="width: 300px" @change="change">
                <el-option v-for="(item,index) in updateInstallOptions" :key="index" :label="item.label"
                  :value="item.key" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('adminView.Version')" prop="versionName">
              <el-input v-model="popObj.versionName" :placeholder="$t('lease.Cannotbeblanked2')"
                @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.UpgradeInstrucZh')" prop="valueEn">
              <el-input v-model="popObj.zh" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.UpgradeInstrucFt')" prop="valueEn">
              <el-input v-model="popObj.ft" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.UpgradeInstrucEn')" prop="valueEn">
              <el-input v-model="popObj.en" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.UpgradeInstrucDe')" prop="valueEn">
              <el-input v-model="popObj.de" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.UpgradeInstrucKl')" prop="valueEn">
              <el-input v-model="popObj.kl" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                @input="change($event)" />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
            <el-form-item :label="$t('appUpdate.UpgradeInstrucJa')" prop="valueEn">
              <el-input v-model="popObj.ja" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                @input="change($event)" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addAndEditDialog = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="submitPop('popObj')">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增/编辑应用中心--弹窗 -->
    <el-dialog :close-on-click-modal="false" width="80%" :visible.sync="appCenterPopShow" @close="appCenterCancel">

      <div slot="title" class="dialog_title">
        {{popTitle}} <span class="lock_btn" @click="editLock = !editLock"><i class="el-icon-lock" v-if="editLock"></i>
          <i class="el-icon-unlock" v-else></i></span>
      </div>

      <el-form id="" ref="appCenterPop" :model="appCenterObj" label-position="right" label-width="200px">

        <el-tabs v-model="activeName">
          <el-tab-pane label="应用信息" name="first">
            <el-row :gutter="40">
              <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.AppName')" prop="appName">
                  <el-input v-model="appCenterObj.appName" :placeholder="$t('lease.Cannotbeblanked2')"
                    :disabled="editLock" @input="change($event)" />
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.Supported1')" prop="version">
                  <el-select v-model="appCenterObj.version" :placeholder="$t('AllDevices.Status')" class="filter-item"
                    :disabled="editLock" style="width: 300px" @change="change">
                    <el-option v-for="(item,index) in versionOptions" :key="index" :label="item.label"
                      :value="item.key" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.logo')" prop="appImg">
                  <div class="uploadBox">
                    <el-input v-model="appCenterObj.appImg" :placeholder="$t('lease.Cannotbeblanked2')"
                      @input="change($event)" :disabled="editLock" />
                    <el-upload ref="upload1" :file-list="fileList1" class="upload-demo appImg" action=""
                      :on-change="handleChange" :auto-upload="false">
                      <el-button v-if="!uploading1" slot="trigger" :disabled="editLock" size="small" type="primary"
                        :loading="uploading1">
                        {{ $t('QR.SelectFile') }}</el-button>
                      <el-button v-if="uploading1" slot="trigger" :disabled="editLock" size="small" type="primary"
                        :loading="uploading1">
                        {{ $t('appUpdate.upload') }}</el-button>
                    </el-upload>
                  </div>
                </el-form-item>
              </el-col>

              <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.GooglePlay')">
                  <el-input v-model="appCenterObj.url2" :placeholder="$t('lease.Cannotbeblanked2')"
                    @input="change($event)" :disabled="editLock" />
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.AppleAppstore')">
                  <el-input v-model="appCenterObj.url3" :placeholder="$t('lease.Cannotbeblanked2')"
                    @input="change($event)" :disabled="editLock" />
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.APPDoc')">
                  <el-input v-model="appCenterObj.doc" @input="change($event)" :disabled="editLock" />
                </el-form-item>
              </el-col>
              <div class="tips">应用版本更新只需修改以下内容</div>
              <!-- 网址下载 -->
              <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.DownloadLink')">
                  <div class="uploadBox">
                    <el-input v-model="appCenterObj.url1" :placeholder="$t('lease.Cannotbeblanked2')"
                      @input="change($event)" />
                    <el-upload ref="upload2" :file-list="fileList2" class="upload-demo url1" action="" clear-files
                      :on-change="handleChange" :auto-upload="false" :disabled="uploading2">
                      <el-button v-if="!uploading2" slot="trigger" size="small" type="primary" :loading="uploading2">
                        {{ $t('QR.SelectFile') }}</el-button>
                      <el-button v-if="uploading2" slot="trigger" size="small" type="primary" :loading="uploading2">
                        {{ $t('appUpdate.upload') }}</el-button>
                    </el-upload>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :sm="12" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.Uploaded')">
                  <!-- <el-input v-model="appCenterObj.url3" :placeholder="$t('lease.Cannotbeblanked2')" @input="change($event)" /> -->
                  <el-date-picker v-model="appCenterObj.updateTime" type="date" :placeholder="$t('yhubReport.Date')" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="应用说明" name="second">
            <el-row :gutter="40">

              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.AppNoteZh')">
                  <el-input v-model="appCenterObj.remark" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                    @input="change($event)" />
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.AppNoteEn')">
                  <el-input v-model="appCenterObj.remarkEn" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                    @input="change($event)" />
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.AppNoteFt')">
                  <el-input v-model="appCenterObj.remarkFt" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                    @input="change($event)" />
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.AppNoteDe')">
                  <el-input v-model="appCenterObj.remarkDe" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                    @input="change($event)" />
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.AppNoteJa')">
                  <el-input v-model="appCenterObj.remarkJa" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                    @input="change($event)" />
                </el-form-item>
              </el-col>
              <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
                <el-form-item :label="$t('appUpdate.AppNoteKl')">
                  <el-input v-model="appCenterObj.remarkKl" :autosize="{ minRows: 2, maxRows: 6}" type="textarea"
                    @input="change($event)" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="appCenterCancel">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="appCenterSubmit('appCenterPop')">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageSysVersionInfo, save, deleteById, list, upload, add, updateById, deleteAppById } from '@/api/appUpdate'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime.js'

export default {
  name: 'DashboardAdmin',
  components: {

  },
  data () {
    return {
      tableData: [],
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      loading: false,
      searchObj: {
        appId: null,
        appName: null,
        appType: null
      },
      addAndEditDialog: false,
      isAdd: true,
      popTitle: '',
      
      popObj: {
        appId: null,
        appName: null,
        appType: null,
        versionName: null,
        updateInstall: null,
        downloadUrl: null
      },
      activeDevice: 'appUpdate',
      appCenterLoading: false,
      appCenterData: [],
      appCenterPopShow: false,
      appCenterObj: {
        id: '',
        appName: '',
        appImg: '',
        url1: '',
        url2: '',
        url3: '',
        version: '',
        doc: ''
      },
      isShowUploadFilePop: false,
      uploading1: false,
      uploading2: false,
      fileList1: [],
      fileList2: [],
      editLock: true,
      activeName: 'first',
      showLock: false
    }
  },
  computed: {
    language () {
      return this.$store.state.language
    },
    // 应用类型
    appTypeOptions () {
      return [
        { key: 1, label: 'IOS' },
        { key: 2, label: this.$t('appUpdate.Android') },
        { key: 3, label: this.$t('appUpdate.website') }
      ]
    },
    updateInstallOptions () {
      return [
        { key: 1, label: this.$t('appUpdate.OrdinaryUpgrade') },
        { key: 2, label: this.$t('appUpdate.MandUpgrade') },
        { key: 3, label: this.$t('appUpdate.notUpgrade') }
      ]
    },
    appCenterRules () {
      return {
        appName: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        appImg: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: ['blur', 'change'] }],
        url1: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: ['blur', 'change'] }],
        url2: [{ required: false, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        url3: [{ required: false, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        version: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: ['blur', 'change'] }],
        updateTime: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: ['blur', 'change'] }]
      }
    },
    versionOptions () {
      return [
        { key: '1', label: 'iOS' },
        { key: '2', label: this.$t('appUpdate.Android') },
        { key: '3', label: 'iOS/' + this.$t('appUpdate.Android') },
        { key: '4', label: 'windows' }
      ]
    },
    rules () {
      return {
        appId: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        appName: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        appType: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: ['blur', 'change'] }],
        versionName: [{ validator: this.checkVersionName, trigger: ['blur', 'change'] }],
        updateInstall: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: ['blur', 'change'] }],
        downloadUrl: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }]
      }
    }
  },
  watch: {
    language (newValue, oldValue) {
      this.queryList()
      this.rules.appId[0].message = this.rules.appName[0].message = this.rules.appType[0].message = this.rules.versionName[0].message = this.rules.updateInstall[0].message = this.rules.downloadUrl[0].message = this.$t('lease.Cannotbeblanked2')
    }
  },
  mounted () {
    this.queryList()
    this.queryAppCenter()
  },
  methods: {
    checkVersionName (rule, value, callback) {
      if (!value) {
        return callback(new Error(this.$t('lease.Cannotbeblanked2')))
      }
      setTimeout(() => {
        if (!/^[0-9]{1}([0-9]|[.])*$/.test(value) || value.indexOf('..') > -1) {
          callback(new Error(this.$t('appUpdate.EnterVersion')))// '请输入正确的版本号。如1.1.1/111'
        } else {
          callback()
        }
      }, 1000)
    },
    queryList () {
      var param = {
        pageNum: 1, // 分页--选中某一页
        pageSize: 100, // 分页--每一页的列表的行数 10 20 50
        appId: this.searchObj.appId,
        appName: this.searchObj.appName,
        appType: this.searchObj.appType
      }
      this.loading = true
      pageSysVersionInfo(param).then(res => {
        this.loading = false
        if (res.resultCode === 1001) {
          if (!res.resultModel) return
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          this.tableData = res.resultModel.list || []
          this.tableData.forEach(v => {
            if (v.updateTime) v.updateTime = getDateAndHour(v.updateTime, 'noSecond')
            this.appTypeOptions.forEach(m => {
              if (v.appType == m.key) v.appTypeZh = m.label
            })
            this.updateInstallOptions.forEach(m => {
              if (v.updateInstall == m.key) v.updateInstallZh = m.label
            })
            v.remarkZh = '--'
            if (v.remark && v.remark.indexOf('{') > -1) {
              v.remark = JSON.parse(v.remark)
              for (var attr in v.remark) {
                if (this.$store.state.language == attr) v.remarkZh = v.remark[attr]
              }
            }
          })
        }
      })
    },
    addOrEdit (row) {
      console.log(row)
      if (this.activeDevice == 'appUpdate') {
        this.addAndEditDialog = true
        this.$nextTick(() => {
          this.$refs.popObj.clearValidate()// 等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.clearValidate(),移除该表单项的校验结果
        })
        if (row) { // 编辑
          for (var attr in row) {
            this.popObj[attr] = row[attr]
            if (attr == 'remark') {
              if (!row.remark) return
              for (var remarkAttr in row.remark) {
                this.popObj[remarkAttr] = row.remark[remarkAttr]
              }
            }
          }
          this.isAdd = false
          this.popTitle = this.$t('adminView.Edit')
        } else { // 新增
          this.popTitle = this.$t('adminView.add')
          this.isAdd = true
          for (var attr1 in this.popObj) this.popObj[attr1] = ''
        }
      } else {
        this.appCenterPopShow = true
        this.uploading1 = this.uploading2 = false
        this.$nextTick(() => {
          this.$refs.appCenterPop.clearValidate()// 等弹窗里的form表单的dom渲染完在执行this.$refs.staffForm.clearValidate(),移除该表单项的校验结果
          this.$refs.upload1.clearFiles()
          this.$refs.upload2.clearFiles()
        })
        if (row) { // 编辑
          for (var attr in row) {
            this.appCenterObj[attr] = row[attr]
            if (attr == 'url') {
              var url = JSON.parse(row.url)
              this.appCenterObj.url1 = url[0]
              this.appCenterObj.url2 = url[1]
              this.appCenterObj.url3 = url[2]
            }
          }
          this.isAdd = false
          this.popTitle = this.$t('adminView.Edit')
        } else { // 新增
          this.popTitle = this.$t('adminView.add')
          this.isAdd = true
          for (var attr1 in this.appCenterObj) this.appCenterObj[attr1] = ''
        }
      }
    },
    deleteOne (id) {
      this.$confirm(this.$t('i18nPage.deleteOne'), '', {// '确定删除该条数据吗？'
        // 是否关闭电子围栏
        confirmButtonText: this.$t('button.Confirm'),
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteById({ id: id }).then(respone => {
          if (respone.resultCode === 1001) {
            this.$message({
              type: 'success',
              message: this.$t('lease.Succeed')
            })
            this.queryList()
          }
        })
      }).catch(() => { })
    },
    submitPop (formName) { // 弹窗--提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.popObj.versionCode = this.popObj.versionName.replace(/\./g, '')
          // this.popObj.versionCode = this.popObj.versionCode.match(/\d+/g).join('')
          var param = JSON.parse(JSON.stringify(this.popObj))
          this.popObj.remark = {}
          for (var attr in param) {
            if (attr.slice(-2) == 'Zh') delete param[attr]
            if (attr == 'zh' || attr == 'ft' || attr == 'en' || attr == 'de' || attr == 'kl' || attr == 'ja') {
              this.popObj.remark[attr] = this.popObj[attr]
              delete param[attr]
            }
          }
          param.remark = JSON.stringify(this.popObj.remark)
          save(param).then(respone => {
            if (respone.resultCode === 1001) {
              this.$message({
                type: 'success',
                message: this.$t('lease.Succeed')
              })
              this.addAndEditDialog = false
              this.queryList()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    appCenterCancel () {
      this.$refs.upload1.abort()
      this.$refs.upload2.abort()
      this.appCenterPopShow = false
    },
    changeSearch () { // 筛选改变事件
      this.replaceFn(this.searchObj.appId)
      this.replaceFn(this.searchObj.appName)
      this.listQuery.pageInfo.pageNum = 1
      this.listQuery.pageInfo.pageSize = 10
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    queryAppCenter () { // 获取应用中心列表数据
      list().then(res => {
        if (res.resultCode == 1001) {
          this.appCenterData = res.resultModel || []
          this.appCenterData.forEach(v => {
            if (v.updateTime) v.updateTimeZh = getDateAndHour(v.updateTime, 'noTime')
            this.versionOptions.forEach(m => {
              if (v.version == m.key) v.versionZh = m.label
            })
          })
        }
      })
    },
    handleChange (file) { // 上传文件
      var classArr = event.target.parentNode.parentNode.className

      var file_name = file.name
      var isyes = false
      var file_nameArr = file_name.split('.')
      var houzui = file_name.split('.')[file_nameArr.length - 1] || ''
      if (classArr.indexOf('appImg') > -1) { // 校验后缀，需注意如：123.png.txt
        this.uploading1 = true
        this.fileList1 = [{ name: file_name, url: '' }]
        this.appCenterObj.appImg = ''
        if (houzui.toLowerCase() == 'png' || houzui.toLowerCase() == 'jpg' || houzui.toLowerCase() == 'jpeg') {
          isyes = true
        }
      } else {
        this.uploading2 = true
        this.fileList2 = [{ name: file_name, url: '' }]
        this.appCenterObj.url1 = ''
        if (houzui.toLowerCase() == 'apk' || houzui.toLowerCase() == 'exe') isyes = true
      }
      if (!isyes) { // 后缀错误
        this.$notify({
          title: this.$t('adminView.IncorrectFile'), // '文件名后缀错误！',
          message: '', // '文件名后缀必须为 "bin" ',
          type: 'error',
          duration: 4000
        })
        if (classArr.indexOf('appImg') > -1) { this.uploading1 = false } else { this.uploading2 = false }
        return
      }
      upload(file).then(response => {
        if (response.resultCode == 1001) {
          this.$notify({
            title: '',
            message: this.$t('lease.Succeed'),
            type: 'success',
            duration: 2000
          })
          if (classArr.indexOf('appImg') > -1) {
            this.appCenterObj.appImg = response.resultModel
          } else {
            this.appCenterObj.url1 = response.resultModel
          }
        }
        if (classArr.indexOf('appImg') > -1) {
          this.uploading1 = false
        } else {
          this.uploading2 = false
        }
      })
    },
    appCenterSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = {
            'appImg': this.appCenterObj.appImg,
            'appName': this.appCenterObj.appName,
            'id': this.appCenterObj.id,
            'updateTime': new Date(this.appCenterObj.updateTime).getTime(),
            'remark': this.appCenterObj.remark,
            'remarkEn': this.appCenterObj.remarkEn,
            'remarkFt': this.appCenterObj.remarkFt,
            'remarkJa': this.appCenterObj.remarkJa,
            'remarkKl': this.appCenterObj.remarkKl,
            'remarkDe': this.appCenterObj.remarkDe,
            'url': JSON.stringify([this.appCenterObj.url1, this.appCenterObj.url2, this.appCenterObj.url3]),
            'version': this.appCenterObj.version,
            'doc': this.appCenterObj.doc
          }
          console.log(param)
          // return
          if (this.isAdd) {
            add(param).then(respone => {
              if (respone.resultCode === 1001) {
                this.$message({
                  type: 'success',
                  message: this.$t('lease.Succeed')
                })
                this.appCenterPopShow = false
                this.queryAppCenter()
              }
            })
          } else {
            updateById(param).then(respone => {
              if (respone.resultCode === 1001) {
                this.$message({
                  type: 'success',
                  message: this.$t('lease.Succeed')
                })
                this.appCenterPopShow = false
                this.queryAppCenter()
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    deleteApp (row) {
      this.$confirm(this.$t('i18nPage.deleteOne'), '', {// '确定删除本条数据吗？'
        confirmButtonText: this.$t('button.Confirm'), // '确定',
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteAppById({ 'id': row.id }).then(res => {
          if (res.resultCode == '1001') {
            this.queryAppCenter()
            this.$message({
              type: 'success',
              message: this.$t('lease.Succeed')
            })
          }
        })
      }).catch(() => {
      })
    },
    replaceFn (val) {
      if (val) { // 去掉首尾空格
        val = val.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
    },
    change (e) {
      this.$forceUpdate()
    },
    // 分页----start
    handleSizeChange (val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>

<style lang="scss">
.dialog_title {
  font-size: 18px;
}
.lock_btn {
  color: #1890ff;
  cursor: pointer;
}
.tips {
  padding-left: 10%;
  font-size: 14px;
  color: #1890ff;
  margin: 20px;
  border-bottom: 1px dotted #1890ff;
}

#appUpdateIndex {
  background: #fff;
  padding: 20px;
  .searchWarp {
    margin-bottom: 10px;
  }
  .searchWarp .el-input-group,
  .searchWarp .el-select {
    width: 20% !important;
    max-width: 400px !important;
    vertical-align: top;
  }
  .el-dialog__body .el-select {
    width: 100% !important;
  }
  .el-tabs__content {
    width: 100%;
  }
  .uploadBox {
    display: flex;
    position: relative;
    .el-input {
      margin-right: 10px;
    }
    .el-upload-list {
      position: absolute;
      top: 23px;
      right: 0px;
      width: 100%;
    }
    .el-upload-list__item-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 0;
      text-align: right;
    }
    .el-upload-list__item .el-icon-close,
    .el-upload-list__item-status-label {
      display: none !important;
    }
  }
}
</style>
